// import React, { useEffect, useState } from "react";
// import useApi from "../../CustomHooks/useApi";
// import { useSelector } from "react-redux";

// const UserProfile = () => {
//   const [userData, setUserData] = useState(null);

//   const userId = useSelector((state) => state.auth.employeeDetails.userId);

//   const { callApi: totalcount } = useApi(
//     `/staff/onboard/get/roles/count`,
//     "GET"
//   );

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await totalcount(null, `?userId=${userId}`);
//         if (response?.UserId) {
//           setUserData(response);
//         }
//       } catch (error) {
//         console.error("Failed to fetch user data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   if (!userData) {
//     return (
//       <div className="min-h-screen bg-[#EEF1F5] flex justify-center p-6">
//         <div className="w-full max-w-5xl bg-white rounded-xl p-6 animate-pulse space-y-4">
//           <div className="h-6 w-1/3 bg-gray-200 rounded" />
//           <div className="h-4 w-1/2 bg-gray-100 rounded" />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-[#EEF1F5] flex justify-center p-6">
//       <div className="w-full max-w-5xl bg-white rounded-xl border border-gray-200 overflow-hidden">

//         {/* ===== Header ===== */}
//         <div className="relative">

//           {/* Cover Banner */}
//           <div className="h-32 bg-gradient-to-r from-[#0A2A4F] to-[#143E73] rounded-t-xl" />

//           {/* Avatar */}
//           <div className="absolute left-8 top-20 z-10">
//             <div className="w-20 h-20 rounded-full bg-[#0A2A4F]
//         flex items-center justify-center
//         text-white text-2xl font-semibold
//         border-4 border-white shadow-lg">
//               {userData.Username?.charAt(0)?.toUpperCase() || "R"}
//             </div>
//           </div>

//           {/* Name & Email */}
//           <div className="pt-16 pb-6 px-8 border-b bg-white">
//             <div className="pl-28">
//               <h2 className="text-xl font-semibold text-gray-900">
//                 {userData.Username}
//               </h2>
//               <p className="text-sm text-gray-500">
//                 {userData.Email}
//               </p>
//             </div>
//           </div>

//         </div>


//         {/* ===== Content ===== */}
//         <div className="p-8 space-y-8">

//           {/* Basic Information */}
//           <div>
//             <h3 className="text-xs font-semibold text-gray-500 uppercase mb-4">
//               Basic Information
//             </h3>

//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//               <div className="border rounded-lg px-5 py-4">
//                 <p className="text-xs text-gray-500 mb-1">User ID</p>
//                 <p className="text-sm font-medium text-gray-900">
//                   {userData.UserId}
//                 </p>
//               </div>

//               <div className="border rounded-lg px-5 py-4">
//                 <p className="text-xs text-gray-500 mb-1">Mobile</p>
//                 <p className="text-sm font-medium text-gray-900">
//                   {userData.Mobile_Number || "N/A"}
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Role Summary */}
//           <div>
//             <h3 className="text-xs font-semibold text-gray-500 uppercase mb-4">
//               Role Summary
//             </h3>

//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//               {["MASTER_DISTRIBUTOR", "DISTRIBUTOR", "MERCHANT"].map((role) => (
//                 <div
//                   key={role}
//                   className="border rounded-lg p-5 space-y-2"
//                 >
//                   <p className="text-sm font-semibold text-[#0A2A4F]">
//                     {role.replace("_", " ")}
//                   </p>

//                   <div className="text-sm text-gray-600 flex justify-between">
//                     <span>Total</span>
//                     <span>{userData[role]?.total ?? 0}</span>
//                   </div>

//                   <div className="text-sm text-gray-600 flex justify-between">
//                     <span>Half Onboarded</span>
//                     <span>{userData[role]?.halfOnboarded ?? 0}</span>
//                   </div>

//                   <div className="text-sm text-gray-600 flex justify-between">
//                     <span>Fully Onboarded</span>
//                     <span>{userData[role]?.fullyOnboarded ?? 0}</span>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default UserProfile;

import React, { useEffect, useState } from "react";
import useApi from "../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const UserProfile = () => {
  const [userData, setUserData] = useState(null);

  const userId = useSelector((state) => state.auth.employeeDetails.userId);

  const { callApi: totalcount } = useApi(
    `/staff/onboard/get/roles/count`,
    "GET"
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await totalcount(null, `?userId=${userId}`);
        if (response?.UserId) {
          setUserData(response);
        }
      } catch (error) {
        console.error("Failed to fetch user data:", error);
      }
    };
    fetchData();
  }, []);

  if (!userData) {
    return (
      <div className="min-h-full bg-[#EEF1F5] flex justify-center p-4 sm:p-6 pb-24 sm:pb-6">
        <div className="w-full max-w-5xl bg-white rounded-xl p-6 animate-pulse space-y-4">
          <div className="h-6 w-1/3 bg-gray-200 rounded" />
          <div className="h-4 w-1/2 bg-gray-100 rounded" />
        </div>
      </div>
    );
  }

  return (
   <div className="min-h-full bg-[#EEF1F5] flex justify-center p-4 sm:p-6 pb-24 sm:pb-6">
      <div className="w-full max-w-5xl bg-white rounded-xl border border-gray-200 overflow-hidden">

        {/* ===== Header ===== */}
        <div className="relative">

          {/* Cover Banner */}
          <div className="h-28 sm:h-32 bg-gradient-to-r from-[#0A2A4F] to-[#143E73] rounded-t-xl" />

          {/* Avatar */}
          <div className="
            absolute
            left-1/2 sm:left-8
            top-20
            -translate-x-1/2 sm:translate-x-0
            z-10
          ">
            <div className="
              w-20 h-20 rounded-full bg-[#0A2A4F]
              flex items-center justify-center
              text-white text-2xl font-semibold
              border-4 border-white shadow-lg
            ">
              {userData.Username?.charAt(0)?.toUpperCase() || "R"}
            </div>
          </div>

          {/* Name & Email */}
          <div className="pt-16 pb-6 px-4 sm:px-8 border-b bg-white text-center sm:text-left">
            <div className="sm:pl-28">
              <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
                {userData.Username}
              </h2>
              <p className="text-sm text-gray-500 break-all">
                {userData.Email}
              </p>
            </div>
          </div>
        </div>

        {/* ===== Content ===== */}
        <div className="p-4 sm:p-8 space-y-8">

          {/* Basic Information */}
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase mb-4">
              Basic Information
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div className="border rounded-lg px-4 sm:px-5 py-4">
                <p className="text-xs text-gray-500 mb-1">User ID</p>
                <p className="text-sm font-medium text-gray-900 break-all">
                  {userData.UserId}
                </p>
              </div>

              <div className="border rounded-lg px-4 sm:px-5 py-4">
                <p className="text-xs text-gray-500 mb-1">Mobile</p>
                <p className="text-sm font-medium text-gray-900">
                  {userData.Mobile_Number || "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* Role Summary */}
          <div>
            <h3 className="text-xs font-semibold text-gray-500 uppercase mb-4">
              Role Summary
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6">
              {["MASTER_DISTRIBUTOR", "DISTRIBUTOR", "MERCHANT"].map((role) => (
                <div
                  key={role}
                  className="border rounded-lg p-4 sm:p-5 space-y-2"
                >
                  <p className="text-sm font-semibold text-[#0A2A4F]">
                    {role.replace("_", " ")}
                  </p>

                  <div className="text-sm text-gray-600 flex justify-between">
                    <span>Total</span>
                    <span>{userData[role]?.total ?? 0}</span>
                  </div>

                  <div className="text-sm text-gray-600 flex justify-between">
                    <span>Half Onboarded</span>
                    <span>{userData[role]?.halfOnboarded ?? 0}</span>
                  </div>

                  <div className="text-sm text-gray-600 flex justify-between">
                    <span>Fully Onboarded</span>
                    <span>{userData[role]?.fullyOnboarded ?? 0}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserProfile;

